import { createContext, useContext, useEffect } from 'react';

const ThemeContext = createContext();

// Shubh design system is light-only
export const ThemeProvider = ({ children }) => {
  const theme = 'light';
  const isDark = false;

  useEffect(() => {
    localStorage.setItem('nakshatra_theme', 'light');
    const root = document.documentElement;
    root.classList.remove('dark');
    root.classList.remove('light');
  }, []);

  const setTheme = () => {};
  const toggleTheme = () => {};

  return (
    <ThemeContext.Provider value={{ theme, setTheme, toggleTheme, isDark }}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = () => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return context;
};

export default ThemeContext;
